"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _react = _interopRequireDefault(require("react"));
function TabContent({
  content,
  classname
}) {
  return /*#__PURE__*/_react.default.createElement("tab-content", {
    class: classname
  }, typeof content === 'string' ? (0, _htmlReactParser.default)(content) : content);
}
var _default = exports.default = TabContent;